import React, { FC } from "react";
import { Grid } from "@mui/material";

interface Props {
  question: any;
}

const TextBlock: FC<Props> = ({ question }) => {
  return (
    <Grid container>
      <Grid item xs={12} className="q-submission-title">
        {question.title}
      </Grid>
      <div
        className="static-note-content"
        dangerouslySetInnerHTML={{ __html: question.static_note || "" }}
      />
    </Grid>
  );
};

export default TextBlock;
